import { Link } from "react-router-dom";
import { getNewComics } from "@/mocks/comics";

export default function LatestUpdates() {
  const newComics = getNewComics();

  return (
    <section className="py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新上架
            </h2>
            <p className="text-sm text-foreground-500 mt-2">刚刚更新的漫画资源</p>
          </div>
          <Link
            to="/category/rexue"
            className="flex items-center gap-1 text-sm text-secondary-700 hover:text-secondary-800 font-medium transition-colors whitespace-nowrap"
          >
            更多新作
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop>
          {newComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all"
            >
              <div className="relative w-20 h-28 md:w-24 md:h-32 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 51漫画最新上架`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-1.5 right-1.5">
                  <span className="px-1.5 py-0.5 bg-accent-500 text-white text-[10px] font-bold rounded">
                    NEW
                  </span>
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                <div className="flex items-center gap-2 mt-2 flex-wrap">
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full">
                    {comic.category}
                  </span>
                  <span className="text-xs text-foreground-400">{comic.chapters}话</span>
                </div>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {comic.description}
                </p>
                <div className="flex items-center gap-1 mt-2 text-xs text-foreground-400">
                  <i className="ri-time-line" />
                  <span>更新于 {comic.updateDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}